import { getSrc } from 'gatsby-plugin-image';
import get from 'lodash/get';
import { PropTypes } from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

import {
  siteDefaultImage,
  siteDescription,
  siteName,
  siteTitle,
  siteType,
  twitterCardStyle,
} from '../../constants/metadata';
import { useSiteUrl } from '../../graphql/hooks/use-site-url';

const getTags = (data, canonicalUrl, created) => {
  const ogImage = data && data.image && getSrc(data.image);

  const title = get(data, 'title', siteTitle);
  const description = get(data, 'description.description', siteDescription);
  const image = `https:${ogImage || siteDefaultImage}`;
  const type = get(data, 'type', siteType);
  const twitterCard = get(data, 'twitterCard', twitterCardStyle);
  const url = canonicalUrl;

  const metadata = [
    {
      content: siteName,
      property: 'og:site_name',
    },
    {
      content: description,
      property: 'og:description',
    },
    {
      content: title,
      property: 'og:title',
    },
    {
      content: url,
      property: 'og:url',
    },
    {
      content: image,
      property: 'og:image',
    },
    {
      content: type,
      property: 'og:type',
    },
    {
      content: twitterCard,
      name: 'twitter:card',
    },
    {
      content: description,
      name: 'twitter:description',
    },
    {
      content: title,
      name: 'twitter:title',
    },
    {
      content: image,
      name: 'twitter:image',
    },
    {
      content: '@couriermedia',
      name: 'twitter:site',
    },
  ];

  if (created) {
    metadata.push({
      content: created,
      name: 'article:published_time',
    });
  }

  return metadata;
};

const Metadata = ({
  created,
  data,
  homepage,
  location = { pathname: '/content/' },
}) => {
  const siteUrl = useSiteUrl();

  // https://www.gatsbyjs.com/docs/location-data-from-props/
  const canonicalUrl = siteUrl + location.pathname;

  const meta = getTags(data, canonicalUrl, created);

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en',
      }}
      meta={meta}
      title={data ? data.title : siteTitle}
      titleTemplate={!homepage && data ? '%s | Couriermedia' : ''}
    >
      <script type="text/javascript">
        {`function OptanonWrapper() {
          if (typeof window.mailchimp_cookie_preferences !== 'undefined') {
            window.mailchimp_cookie_preferences.syncPreferences();
          }
        }`}
      </script>
    </Helmet>
  );
};

Metadata.propTypes = {
  created: PropTypes.number,
  data: PropTypes.object,
  homepage: PropTypes.bool,
  location: PropTypes.object,
};

export default Metadata;
